import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Paper,
    Typography,
    IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

/**
 * Componente que permite seleccionar viajeros de una orden de servicio
 * para ser incluidos en un manifiesto específico.
 */
const TravelerSelector = ({ open, handleClose, ordenDetalle = [], manifiesto, trayecto, viajerosAsociados = [], onSubmit }) => {
    const [selectedTravelers, setSelectedTravelers] = useState([]);
    const [selectedOriginals, setSelectedOriginals] = useState([]);
    const [availableTravelers, setAvailableTravelers] = useState([]);

    useEffect(() => {
        if (open && ordenDetalle.length > 0) {
            const disponibles = ordenDetalle.filter((t) => !t.mandetid);
            //const asignados = ordenDetalle.filter((t) => !!t.mandetid);
            const asignados = ordenDetalle.filter(
                (t) =>
                    !!t.mandetid &&
                    viajerosAsociados.some((v) => v.perid === t.perid)
            );
            setAvailableTravelers(disponibles.sort((a, b) => a.pernom.localeCompare(b.pernom)));
            setSelectedTravelers(asignados.sort((a, b) => a.pernom.localeCompare(b.pernom)));
            setSelectedOriginals(asignados);
        }
    }, [open, ordenDetalle]);

    useEffect(() => {
        if (open) {
            window.scrollTo(0, 0);
        }
    }, [open]);

    const handleAddTraveler = (id) => {
        const traveler = availableTravelers.find((t) => t.ordserdetid === id);
        if (traveler) {
            setSelectedTravelers((prev) => [...prev, traveler]);
            setAvailableTravelers((prev) => prev.filter((t) => t.ordserdetid !== id));
        }
    };

    const handleRemoveTraveler = (id) => {
        const traveler = selectedTravelers.find((t) => t.ordserdetid === id);
        if (traveler) {
            setAvailableTravelers((prev) => [...prev, traveler]);
            setSelectedTravelers((prev) => prev.filter((t) => t.ordserdetid !== id));
        }
    };

    const handleConfirm = () => {
        /*if (selectedTravelers.length === 0) {
            alert("Debe seleccionar al menos un viajero.");
            return;
        }*/
        onSubmit(selectedTravelers, selectedOriginals);
    };

    const handleAddAll = () => {
        setSelectedTravelers((prev) => [...prev, ...availableTravelers]);
        setAvailableTravelers([]);
    };

    const handleRemoveAll = () => {
        setAvailableTravelers((prev) => [...prev, ...selectedTravelers]);
        setSelectedTravelers([]);
    };

    const renderTravelerBox = (traveler, actionIcon, onClick) => (
        <Box key={traveler.ordserdetid} display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: 1, mb: 1, borderRadius: 2, backgroundColor: "#fff", boxShadow: 1 }}>
            <Box>
                <Typography fontWeight="bold">{traveler?.pernom}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {traveler?.puntosubida || "Sin punto de subida"} → {traveler?.puntobajada || "Sin punto de bajada"}
                </Typography>
            </Box>
            <IconButton onClick={() => onClick(traveler.ordserdetid)} color={actionIcon === "add" ? "primary" : "error"}>
                {actionIcon === "add" ? <AddCircleIcon /> : <RemoveCircleIcon />}
            </IconButton>
        </Box>
    );

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Asignar Pasajeros al Manifiesto</DialogTitle>
            <DialogContent>
                <Box display="flex" gap={2} mt={1}>
                    {/* Seleccionados */}
                    <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Pasajeros Seleccionados
                        </Typography>
                        {selectedTravelers.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">Sin pasajeros seleccionados.</Typography>
                        ) : (
                            selectedTravelers.map((traveler) => renderTravelerBox(traveler, "remove", handleRemoveTraveler))
                        )}
                    </Paper>

                    {/* Disponibles */}
                    <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Pasajeros Disponibles ({trayecto})
                        </Typography>
                        {availableTravelers.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">Sin pasajeros disponibles.</Typography>
                        ) : (
                            availableTravelers.map((traveler) => renderTravelerBox(traveler, "add", handleAddTraveler))
                        )}
                    </Paper>
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={2}>
                    <Button onClick={handleAddAll} disabled={availableTravelers.length === 0} variant="outlined" color="primary">
                        Adicionar Todos
                    </Button>
                    <Button onClick={handleRemoveAll} disabled={selectedTravelers.length === 0} variant="outlined" color="error">
                        Quitar Todos
                    </Button>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={handleConfirm} variant="contained">Guardar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TravelerSelector;
